const actions = {
  CREATE_MEMBER_TRANSACTION: 'CREATE_MEMBER_TRANSACTION',
  CREATE_MEMBER_TRANSACTION_ENDED: 'CREATE_MEMBER_TRANSACTION_ENDED',
  SEARCH_MEMBER_TRANSACTIONS: 'SEARCH_MEMBER_TRANSACTIONS',
  SEARCH_MEMBER_TRANSACTIONS_ENDED: 'SEARCH_MEMBER_TRANSACTIONS_ENDED',
  FIND_MEMBER_TRANSACTION: 'FIND_MEMBER_TRANSACTION',
  FIND_MEMBER_TRANSACTION_ENDED: 'FIND_MEMBER_TRANSACTION_ENDED',
};
export default actions;
